















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'ProductionIos'
})
export default class extends Vue {
  showNav = true
}
